import React from 'react';
import { Row, Container } from 'reactstrap';
import ActivityCard from './ActivityCard';
import AdministratorBrowser from './AdministratorBrowser';
import BestSellingProduct from './BestSellingProduct';
import CompanyOverview from './CompanyOverview';
import InvestmentSlider from './InvestmentSlider';
import ProfitOverview from './ProfitOverview';
import SellOverview from './SellOverview';
import WeatherCard from './WeatherCard';
import WelcomeCard from './WelcomeCard';

const ContainerDefault = () => {
  return (
    <Container fluid={true} className='default-dash'>
      <Row>
        <WelcomeCard />
        <CompanyOverview />
        <InvestmentSlider />
        <SellOverview />
        <AdministratorBrowser />
        <ProfitOverview />
        <BestSellingProduct />
        <WeatherCard />
        <ActivityCard />
      </Row>
    </Container>
  );
};

export default ContainerDefault;
